import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-panel" }

import { ref } from "vue";
import { VBtn } from "v-ferry-components";
import SvgIcon from "@/components/icons/SvgIcon.vue";

interface Props {
    btnText: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoPanel',
  props: {
    btnText: {}
  },
  setup(__props: any) {



const isDrawerActive = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["content-drawer", { active: isDrawerActive.value }])
    }, _cache[1] || (_cache[1] = [
      _createStaticVNode("<div class=\"content-drawer__inner\" data-v-146f9e1e><h3 data-v-146f9e1e>How it works</h3><h4 data-v-146f9e1e>What is considered a freight booking?</h4><p data-v-146f9e1e>A vehicle longer than 6 metres or higher than 2.6 metres or if you are shipping commercial goods or tools, you are in the right place.</p><h4 data-v-146f9e1e>Are you a new customer?</h4><p data-v-146f9e1e>Bookings can be made through the New Customer portal. Our commercial team are also available to offer bespoke solutions to meet your business needs. <a href=\"/freight/business-information/contact-us/\" data-v-146f9e1e>Talk to us</a>.</p><h4 data-v-146f9e1e>Have you sailed with us before?</h4><p data-v-146f9e1e>If so please login through the existing customer or please reach out <a href=\"/freight/business-information/contact-us/\" data-v-146f9e1e>here</a> if you have any questions.</p></div>", 1)
    ]), 2),
    _createVNode(_unref(VBtn), {
      class: "v-btn--toggle",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isDrawerActive.value = !isDrawerActive.value))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.btnText) + " ", 1),
          _createVNode(SvgIcon, {
            icon: "chevron-down",
            width: "1rem",
            height: "1rem"
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})